/**
 * Sound feedback for PDV operations.
 * Uses Web Audio API for instant, low-latency beeps.
 */

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
}

function playBeep(frequency: number, duration: number, type: OscillatorType = 'sine'): void {
  try {
    const ctx = getAudioContext();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.frequency.value = frequency;
    oscillator.type = type;
    gainNode.gain.value = 0.3;

    // Fade out to avoid click
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);

    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + duration);
  } catch {
    // Audio not available (e.g., user hasn't interacted yet)
  }
}

/** Success beep - product scanned successfully */
export function beepSuccess(): void {
  playBeep(1200, 0.1);
}

/** Error beep - product not found or out of stock */
export function beepError(): void {
  playBeep(300, 0.2, 'square');
  setTimeout(() => playBeep(200, 0.3, 'square'), 200);
}

/** Payment complete beep */
export function beepPayment(): void {
  playBeep(800, 0.1);
  setTimeout(() => playBeep(1000, 0.1), 100);
  setTimeout(() => playBeep(1200, 0.15), 200);
}

/** Warning beep - low stock */
export function beepWarning(): void {
  playBeep(600, 0.15, 'triangle');
}
